import React from 'react';
import { Users } from 'lucide-react';

export default function Community() {
  const gradients = [
    'from-[#a020c9] to-[#ec2fd2]',
    'from-[#7a1fb0] to-[#a020c9]',
    'from-[#ec2fd2] to-[#ff6ba0]',
  ];
  return (
    <section className="gradient-bg-purple py-20 relative">
      <div className="wave-divider-top">
        <svg viewBox="0 0 1440 80" preserveAspectRatio="none">
          <path d="M0,32 C240,72 480,72 720,48 C960,24 1200,24 1440,56 L1440,80 L0,80 Z" fill="#f7ecff"></path>
        </svg>
      </div>
      <div className="max-w-5xl mx-auto px-6 text-center text-white pt-10">
        <p className="tracking-widest text-sm font-semibold uppercase text-white/80">— Momentos da Turma —</p>
        <h2 className="font-heading font-extrabold text-3xl md:text-4xl mt-2 mb-4">&ldquo;Na ADP eu aprendi muita matemática e fiz bons amigos também.&rdquo;</h2>
        <p className="text-white/85 mb-10">A comunidade ADP vai além das aulas — é onde conexões reais acontecem.</p>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          {gradients.map((g, i) => (
            <div key={i} className={`rounded-2xl overflow-hidden shadow-2xl bg-gradient-to-br ${g} aspect-[4/3] flex items-center justify-center`}>
              <Users size={72} className="text-white/90" />
            </div>
          ))}
        </div>
      </div>
      <div className="wave-divider-bottom">
        <svg viewBox="0 0 1440 80" preserveAspectRatio="none">
          <path d="M0,32 C240,72 480,72 720,48 C960,24 1200,24 1440,56 L1440,80 L0,80 Z" fill="#f7ecff"></path>
        </svg>
      </div>
    </section>
  );
}
